import { createAction } from '../util/index.js';

export const navMenuToggle = createAction('NAVIGATION_MENU_TOGGLE', { noPayload: true });
export const navMenuclose = createAction('NAVIGATION_MENU_CLOSE', { noPayload: true });
export const openNavMenu = createAction('NAVIGATION_MENU_OPEN', { noPayload: true });
export const toggleAddSupplerButton = createAction('ADD_SUPPLIER_TOGGLE', requestObject => requestObject);
export const litmosCheckBoxValue = value => {
  return {
    type: 'LITMOS_CHECKBOX_VALUE',
    payload: value
  };
};